import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Contact } from '../../../contacts/contracts/contact.interface';
import { ContactAvatarPipe } from '../../pipes/contact-avatar.pipe';
import { CONVERSATION_AVATAR_COLORS } from '../../constants/conversation-avatar-map';

@Component({
  selector: 'app-conversation-initials',
  standalone: true,
  imports: [
    NgStyle,
    NgIf,
    ContactAvatarPipe,
    NgClass
  ],
  templateUrl: './conversation-initials.component.html',
  styleUrls: ['./conversation-initials.component.scss']
})
export class ConversationInitialsComponent implements OnChanges {

  @Input() contact?: Contact;
  @Input() conversationAvatarId?: number;
  @Input() rounded: boolean = false;
  @Input() height?: string;
  @Input() width?: string;
  @Input() fontSize: string = '24px';

  avatarStyle!: { [key: string]: string };

  ngOnChanges(changes: SimpleChanges): void {
    this.updateStyle();
  }

  private updateStyle(): void {
    const colorId = this.contact?.id != null ? ((this.contact.id % 10) + 1) : 1;
    const style = CONVERSATION_AVATAR_COLORS[colorId] ?? CONVERSATION_AVATAR_COLORS[1];

    this.avatarStyle = {
      background: style.background,
      color: style.color,
      ...(this.height ? { height: this.height } : {}),
      ...(this.width ? { width: this.width } : {}),
      ...(this.fontSize ? { fontSize: this.fontSize } : {})
    };
  }
}
